import { SettingConst } from '@faire/web-api--source/types';

/**
 * Control whether we show the expected add to cart amount on the add to cart button for retailers
 */
export const GROWTH_HACK_SHOW_EXPECTED_ADD_TO_CART_AMOUNT_ON_ATC_BUTTON_250613 =
  'GROWTH_HACK_SHOW_EXPECTED_ADD_TO_CART_AMOUNT_ON_ATC_BUTTON_250613' as SettingConst<
    'GROWTH_HACK_SHOW_EXPECTED_ADD_TO_CART_AMOUNT_ON_ATC_BUTTON_250613',
    boolean,
    'RETAILER' | 'HOTJAR_RETAILER'
  >;
